module.exports = __webpack_public_path__ + "img/bb-image.bab860dc.svg";